/**
 * Simple bar chart — direct port of MAFA's `.barwrap` from ui.jsx. The
 * caller supplies an array of (label, value) pairs; the chart picks the
 * tallest as the scale max and animates fills with CSS transitions
 * defined in global.css.
 *
 * Kept dependency-free on purpose: bringing in Recharts or visx for a
 * five-pixel bar would be wildly disproportionate.
 */

export type BarDatum = {
  label: string;
  value: number;
  highlight?: boolean;
  hint?: string;
};

type Props = {
  data: BarDatum[];
  height?: number;
};

export function BarChart({ data, height = 130 }: Props) {
  if (data.length === 0) {
    return (
      <div className="muted" style={{ padding: 24, textAlign: 'center', fontSize: 13 }}>
        Aucune donnée à afficher.
      </div>
    );
  }
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <div>
      <div className="barwrap" style={{ height }}>
        {data.map((d, i) => (
          <div
            key={i}
            className={'b' + (d.highlight ? ' hi' : '')}
            style={{ height: Math.max(4, (d.value / max) * height) + 'px' }}
            title={d.hint ?? `${d.label}: ${d.value.toLocaleString('fr-FR')}`}
          />
        ))}
      </div>
      <div style={{ display: 'flex', marginTop: 8 }}>
        {data.map((d, i) => (
          <div
            key={i}
            style={{
              flex: '1 1 0',
              textAlign: 'center',
              fontSize: 10.5,
              fontWeight: 600,
              color: 'var(--ink-4)',
            }}
          >
            {d.label}
          </div>
        ))}
      </div>
    </div>
  );
}
